import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'
import { ReactSVG } from 'react-svg'
import Transmission from 'components/Transmission'
import { selectDashboardTransmissions } from 'store/global'
import { selectTransmissions, startTransmissions } from 'store/dashboard'
import messages from './messages'
import styles from './DashboardBackdrop.scss'

import { allCoordinates } from './coordinates'

const EXTERNAL_DATA_SOURCES = ['linkedin', 'facebook', 'airbnb', 'maps', 'googleAds']
const CONNECTING_LINES = ['internal', 'linkedin', 'maps', 'airbnb', 'facebook', 'googleAds']
const RESOLVER_LINES = ['rental', 'gig', 'ecommerce', 'nexus']

function DashboardBackdrop({ children, className }) {
  const dispatch = useDispatch()

  const allTransmissions = useSelector(selectDashboardTransmissions)
  const transmissions = useSelector(selectTransmissions)

  useEffect(() => {
    dispatch(startTransmissions(allTransmissions))
  }, [allTransmissions])

  return (
    <div className={cx(styles.container, className)}>
      <img src={require('./assets/engine.png')} className={styles.engine} />
      <ReactSVG src={require('./assets/opacity.svg')} className={styles.opacity} />
      <ReactSVG src={require('./assets/diagonal.svg')} className={styles.diagonal} />
      <span className={cx(styles.label, styles.external)}>
        <FormattedMessage {...messages.labels.external} />
      </span>
      {EXTERNAL_DATA_SOURCES.map(name => (
        <ReactSVG
          key={name}
          src={require(`./assets/${name}.svg`)}
          className={cx(styles.svg, styles.external, styles[name])}
        />
      ))}
      <img src={require('./assets/internal.png')} className={cx(styles.svg, styles.internal)} />
      <span className={cx(styles.label, styles.internal)}>
        <FormattedMessage {...messages.labels.internal} />
      </span>
      {CONNECTING_LINES.map(key => (
        <ReactSVG key={key} src={require(`./assets/line-${key}.svg`)} className={cx(styles.line, styles[key])} />
      ))}
      {RESOLVER_LINES.map(key => (
        <ReactSVG key={key} src={require(`./assets/line-${key}.svg`)} className={cx(styles.line, styles[key])} />
      ))}
      {Object.entries(transmissions).map(([uuid, transmission]) => (
        <div key={uuid} className={cx(styles.transmission, styles[transmission.coordinatesKey])}>
          <Transmission
            type={transmission.type}
            speed={transmission.speed}
            coordinates={allCoordinates[transmission.coordinatesKey]}
          />
        </div>
      ))}
      {children}
    </div>
  )
}

export default DashboardBackdrop
